import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#1D9BF0" },
    background: {
      default: "#000000",
      paper: "#000000",
      hover: "rgba(255, 255, 255, 0.03)",
    },
    text: {
      primary: "#E7E9EA",
      secondary: "#71767B",
    },
    divider: "#2F3336",
  },
  typography: {
    fontFamily:
      "'Chirp', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h6: {
      fontSize: "1.25rem",
      fontWeight: 700,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.938rem",
      lineHeight: 1.4,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        },
        "html, body": {
          backgroundColor: "#000000",
          width: "100%",
          minHeight: "100%",
          "@supports (height: 100dvh)": {
            minHeight: "100dvh",
          },
          overflowX: "hidden",
        },
        "#root": {
          width: "100%",
          minHeight: "100%",
          "@supports (height: 100dvh)": {
            minHeight: "100dvh",
          },
          backgroundColor: "#000000",
        },
        /* keep off-screen PostCards mounted but skip paint/layout */
        ".post-card": {
          contentVisibility: "auto",
          containIntrinsicSize: "560px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "0.938rem",
          fontWeight: 700,
          borderRadius: "9999px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          backgroundImage: "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.03)",
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "#000000",
          padding: 0,
          margin: "0 auto",
          "@media (min-width: 600px)": {
            maxWidth: "600px",
          },
        },
      },
    },
  },
});

export default darkTheme;
